import VideoGridViewerFooter from './VideoGridViewerFooter';

export default VideoGridViewerFooter;
